export default {
      id: "certificate-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#certificate",
      toString: function () {
        return this.url;
      }
    }